// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchAuthorsView__breadCrumbs"};